<template>
    <div class="box">
        <Header></Header>
      <!--业务范围-->
        <section>
            <img style="width: 100%;height: 150px;" :src="banner.path" alt="">
          <div class="nav" style="padding: 0 10px;margin-top: 10px;">
            <p style="border-left: 3px solid #BB1E10;padding-left: 10px;font-size: 17px;color: #333333;font-weight: bold;">{{typefaces == 1 ? '甘其毛都口岸' : 'The Ganqimaodu Port'}}</p>
            <p style="font-size: 14px;color:#909090;padding-top: 20px;">{{typefaces == 1 ? textGanqiMaodu:textGanqiMaoduEng}}</p>
            <img style="width: 100%;height: auto;margin-top: 20px;" :src="pathGanqiMaodu" alt="">

            <p style="border-left: 3px solid #BB1E10;padding-left: 10px;margin-top: 35px;font-size: 17px;color: #333333;font-weight: bold;">{{typefaces == 1 ? '满都拉口岸' : 'The Mandula Port'}}</p>
            <p style="font-size: 14px;color:#909090;padding-top: 20px;">{{typefaces==1?textMandul:textMandulEng}}</p>
            <img style="width: 100%;height: auto;margin-top: 20px;" :src="pathMandul" alt="">

            <p style="border-left: 3px solid #BB1E10;padding-left: 10px;margin-top: 35px;font-size: 17px;color: #333333;font-weight: bold;">{{typefaces == 1 ? '二连浩特口岸' : 'The Erenhot Port'}}</p>
            <p style="font-size: 14px;color:#909090;padding-top: 20px;">{{typefaces==1?text:textEng}}</p>
            <img style="width: 100%;height: auto;margin-top: 20px;" :src="path" alt="">

            <p style="border-left: 3px solid #BB1E10;padding-left: 10px;margin-top: 35px;font-size: 17px;color: #333333;font-weight: bold;">{{typefaces == 1 ? '海煤业务' : 'Seaborne trade'}}</p>
            <p style="font-size: 14px;color:#909090;padding-top: 20px;">{{typefaces==1?textHaiMei:textHaiMeiEng}}</p>
            <img style="width: 100%;height: auto;margin-top: 20px;" :src="pathHaiMei" alt="">

            <p style="border-left: 3px solid #BB1E10;padding-left: 10px;margin-top: 35px;font-size: 17px;color: #333333;font-weight: bold;">{{typefaces == 1 ? '乌拉特中旗' : 'The Urad Middle Banner'}}</p>
            <p style="font-size: 14px;color:#909090;padding-top: 20px;">{{typefaces==1?textWuLaTe:textWuLaTeEng}}</p>
            <img style="width: 100%;height: auto;margin-top: 20px;" :src="pathWuLaTe" alt="">

            <p style="border-left: 3px solid #BB1E10;padding-left: 10px;margin-top: 35px;font-size: 17px;color: #333333;font-weight: bold;">{{typefaces == 1 ? '东乌珠穆沁旗' : 'The Dongwu Banner'}}</p>
            <p style="font-size: 14px;color:#909090;padding-top: 20px;">{{typefaces==1?textDongWu:textDongWuEng}}</p>
            <img style="width: 100%;height: auto;margin-top: 20px;" :src="pathDongWu" alt="">

          </div>

          <Footer :typeFaces="typeFacesNumber" ></Footer>
        </section>
    </div>
</template>

<script>
import axios from 'axios';
import Header from '../Header';
import Footer from '../Footer';

export default {
	name: 'Ganqimaodu',
	components: {
		Header,
        Footer
	},
	data () {
		return {
      typefaces: 1,
      typeFacesNumber: 0,
            banner: {},
      textGanqiMaodu: '',
      textGanqiMaoduEng: '',
      pathGanqiMaodu: '',
      textMandul: '',
      textMandulEng: '',
      pathMandul: '',
      textHaiMei: '',
      textHaiMeiEng: '',
      pathHaiMei: '',
      textWuLaTe: '',
      textDongWu: '',
      textWuLaTeEng: '',
      pathWuLaTe: '',
      pathDongWu: '',
      text: '',
      textEng: '',
      path: ''
		}
	},
  computed: {
    aaa() {
      return this.$root.TYPEFACE;
    }
  },
  watch:{
    aaa(type) {
      this.typefaces = type;
    },
  },

	mounted() {
    this.typefaces = (this.$root.TYPEFACE == undefined ? this.typefaces : this.$root.TYPEFACE);
        this.getData();
    this.getGanqiMaoduList();
    this.getMandulList();
    this.getList();
    this.getHaiMeiList();
    this.getWuLaTeList();
    this.getDongWuList();
	},

	methods: {
    fatherMethod(type) {
      this.typefaces = type;
      this.typeFacesNumber = type;
    },
    // 获取轮播图
    getData() {
      axios({
        url: this.url + '/content/input/fileList',
        method: 'post',
        data: {
          parentId: 0,
          type: 14
        },
      }).then(res => {
        this.banner = res.data[0][0];
      });
    },

    // 获取甘其毛都口岸
    getGanqiMaoduList() {
      axios({
        url: this.url + '/content/business/list?type=0',
        method: 'get',
        data: {},
      }).then(res => {
        this.textGanqiMaodu = res.data.rows[0].text;
        this.textGanqiMaoduEng = res.data.rows[0].textEng;
        this.pathGanqiMaodu = res.data.rows[1].path;
      });
    },
    // 获取满都拉口岸
    getMandulList() {
      axios({
        url: this.url + '/content/business/list?type=1',
        method: 'get',
        data: {},
      }).then(res => {
        this.textMandul = res.data.rows[0].text;
        this.textMandulEng = res.data.rows[0].textEng;
        this.pathMandul = res.data.rows[1].path;
      });
    },

    // 获取二连浩特口岸
    getList() {
      axios({
        url: this.url + '/content/business/list?type=3',
        method: 'get',
        data: {},
      }).then(res => {
        this.text = res.data.rows[0].text;
        this.textEng = res.data.rows[0].textEng;
        this.path = res.data.rows[1].path;
      });
    },
    // 获取海煤业务
    getHaiMeiList() {
      axios({
        url: this.url + '/content/business/list?type=4',
        method: 'get',
        data: {},
      }).then(res => {
        this.textHaiMei = res.data.rows[0].text;
        this.textHaiMeiEng = res.data.rows[0].textEng;
        this.pathHaiMei = res.data.rows[1].path;
      });
    },
    // 获取乌拉特中旗
    getWuLaTeList() {
      axios({
        url: this.url + '/content/business/list?type=2',
        method: 'get',
        data: {},
      }).then(res => {
        this.textWuLaTe = res.data.rows[0].text;
        this.textWuLaTeEng = res.data.rows[0].textEng;
        this.pathWuLaTe = res.data.rows[1].path;
      });
    },
    // 获取乌拉特中旗
    getDongWuList() {
      axios({
        url: this.url + '/content/business/list?type=5',
        method: 'get',
        data: {},
      }).then(res => {
        this.textDongWu = res.data.rows[0].text;
        this.textDongWuEng = res.data.rows[0].textEng;
        this.pathDongWu = res.data.rows[1].path;
      });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

html, body {
    margin: 0;
    padding: 0;
    overflow-x: hidden;
}
p, span, ul, li{
    margin: 0;
    padding: 0;
}
.box {
    display: flex;
    flex-direction: column;
    height: 100vh;
    overflow: hidden;
}

section {
    flex: 1;
    overflow-y: scroll;
}

</style>



// WEBPACK FOOTER //
// src/components/Business/ganqimaodu.vue